import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  textPrimary: {
    fontWeight: "bold",
    fontSize: "1.5rem",
    textAlign: "start",
  },
  secondaryText: {
    fontSize: "1rem",
    textAlign: "center",
  },
  typography: {
    display: "flex",
    justifyContent: "flex-start",
  },
  styleImg: {
    height: "20px",
    margin: "0px",
  },
}))

export default useStyles
